module.exports = __webpack_public_path__ + "assets/img/1_1642_big.39e93017.jpg";